import { AppState } from '../store';

export const availableDiscountsSelector = (state: AppState) =>
  state.discounts.availableDiscounts;

export const appliedDiscountsSelector = (state: AppState) =>
  state.discounts.appliedDiscounts;

export const updatedDiscountsSelector = (state: AppState) =>
  state.discounts.updatedDiscounts;

export const unavailableDiscountsSelector = (state: AppState) =>
  state.discounts.unavailableDiscounts;

export const fetchDiscountsStateSelector = (state: AppState) =>
  state.discounts.fetchDiscountsState;

export const addDiscountStateSelector = (state: AppState) =>
  state.discounts.addDiscountState;

export const removeDiscountStateSelector = (state: AppState) =>
  state.discounts.removeDiscountState;

export const removeDiscountsStateSelector = (state: AppState) =>
  state.discounts.removeDiscountsState;

export const clearDiscountsStateSelector = (state: AppState) =>
  state.discounts.clearDiscountsState;
